export enum CustomTipType {
  dollars = 'dollars',
  percent = 'percent'
}
